export type FileMimeType = 'image/jpg' | 'image/png' | 'image/jpeg';
